<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-calendar-month
      </v-icon> App Subscriptions
    </h2>
    <br>
    <br>
    <v-card
      v-if="!isOrgAppModuleExist"
      color="#CFD8DC"
      class="app-modules"
    >
      <p class="my-alert-style">
        No App Modules Found.
      </p>
    </v-card>
    <v-tabs
      v-model="tab"
      color="#FF3700"
      background-color="#ECEFF1"
    >
      <v-tab
        v-for="(item, index) in orgAppModules"
        :key="index"
        @click="fetchClickedAppSubscription(item.name)"
      >
        {{ item.name }}
      </v-tab>
    </v-tabs>
    <centre-spinner
      :loading="loading"
    />
    <org-subscription-details
      v-if="isOrgAppModuleExist"
      ref="orgModules"
    />
  </v-container>
</template>
<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import OrgSubscriptionDetails from './OrgSubscriptionDetails.vue';
  export default {
    name: 'OrgSubscriptions',
    components: {
      'centre-spinner': spinner,
      'org-subscription-details': OrgSubscriptionDetails,
    },
    data: () => ({
      tab: null,
      orgAppModules: [],
      currentActiveTab: '',
      loading: false,
    }),
    computed: {
      organizationDetails () {
        return this.$store.getters['organizations/getOrganizationDetails'];
      },
      isOrgAppModuleExist () {
        if (Object.keys(this.organizationDetails).length > 0 && this.organizationDetails.app_modules.length > 0) {
          return true;
        }
        return false;
      },
    },
    async mounted () {
      this.loading = true;
      await this.loadAppModules();
      this.loading = false;
    },
    methods: {
      async loadAppModules () {
        this.loading = true;
        if (this.isOrgAppModuleExist === true) {
          this.orgAppModules = this.organizationDetails.app_modules;
          this.currentActiveTab = this.orgAppModules[0].name;
          this.$refs.orgModules.fetchOrgSubscriptionDetails(this.currentActiveTab);
          this.loading = false;
          return;
        }
        this.loading = false;
      },
      async fetchClickedAppSubscription  (val) {
        this.$refs.orgModules.fetchOrgSubscriptionDetails(val);
      },
    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
  margin-left: 20px;
}
.my-tabs-background-style {
    background-color: #ECEFF1 !important;
}
.app-modules {
  padding-top: 50px;
  padding-bottom: 50px;
}
.my-alert-style {
  font-size: 18px;
  font-weight: bold;
  color: #C62828;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  text-align: center;
}
</style>
